import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92ac3606"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Energietechnik", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "Wittenberg GmbH", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_list = _resolveComponent("ion-list")!

  return (_openBlock(), _createBlock(_component_ion_list, {
    class: _normalizeClass(["logo-container", _ctx.classVal])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_item, {
        class: "img-container",
        lines: "none"
      }, {
        default: _withCtx(() => [
          (_ctx.type === '1')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/logo-white.svg'),
                class: "loading-logo"
              }, null, 8, _hoisted_1))
            : (_ctx.type === '2' || _ctx.type === '3')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/logo-blue.svg'),
                  class: "loading-logo"
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_list, { class: "text-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, {
            color: _ctx.textColor,
            class: "logo-title"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_ion_text, {
            color: _ctx.textColor,
            class: "logo-subtitle"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}